/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of privcats (patients) to display or load privcats */


(function () {
  'use strict';
  angular.module('vcfinance.privcat')
    .component('privcatgrouplist', {
      restrict: 'E',
      bindings: {
        privcatgroups: '<?'
      },
      template: `
        <table class="table table-striped">
          <thead>
          <tr>
            <th>Kürzel</th>
            <th>Bezeichnung</th>
            <th>Aktion</th>
          </tr>
          </thead>
          <tr ng-repeat="group in vm.privcatgroups">
            <td>{{group.shortcut}}</td>
            <td>{{group.name}}</td>
            <td>
              <button class="btn btn-primary" ng-click="vm.editGroup(group)"><i class="fa fa-edit" uib-tooltip="Editieren"></i></button>
              <button class="btn btn-danger" ng-click="vm.removeGroup(group)"><i class="fa fa-remove" uib-tooltip="Löschen"></i></button>
            </td>
          </tr>
          <tr ng-repeat-end>
            <td colspan="3">
            <div ng-if="vm.editgroup[$index]"
            
</td>
          </tr>
        </table>
      `,
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'Privcat', 'PrivcatHelper', 'vertxEventBusService',
        function ($log, $http, Rlog, Privcat, PrivcatHelper, vertxEventBusService) {
          let vm = this;
          vm.editGroup = PrivcatHelper.editPrivcatGroup;
          vm.removeGroup = removeGroup;
          
          vm.$onInit = function () {
            
            // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
            if (angular.isUndefined(vm.privcatgroups)) {
              vm.privcatgroups = Privcat.$search({type: 'group', active: true});
            }
          }; // $onInit()
          
          
          function removeGroup(entry) {
            entry.active = false;
            entry.$save();
          }

          const privcatUpdateHandler = function (message) {
            $log.debug('debug: privcat update received: ', message);
            let messages = message.split(':');
            if (angular.isDefined(vm.privcatgroups)){
              vm.privcatgroups.$refresh().$then(function () {
                $log.debug('debug: privcatgrouplist refreshed privcat');
              }, function (error) {
                $log.debug('debug: privcatgrouplist refresh failed: ', error);
              });
            }
          };

          vertxEventBusService.on('privcat.update', {}, privcatUpdateHandler);

          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('privcat.update', {}, privcatUpdateHandler);
          };




        }] // controller
    }); // component
  
  // klammerfriedhof
}());